export enum DATA_TYPES {
	STRING = "STRING",
	TEXT = "TEXT",
	INTEGER = "INTEGER",
	FLOAT = "FLOAT",
	REAL = "REAL",
	DOUBLE = "DOUBLE",
	DECIMAL = "DECIMAL",
	DATE = "DATE",
	DATEONLY = "DATEONLY",
	BOOLEAN = "BOOLEAN",
	ARRAY = "ARRAY",
	JSON_ = "JSON_",
	BLOB = "BLOB",
	UUID = "UUID",
}

export const dataTypesSequelize = [
	DATA_TYPES.STRING,
	DATA_TYPES.TEXT,
	DATA_TYPES.INTEGER,
	DATA_TYPES.FLOAT,
	DATA_TYPES.REAL,
	DATA_TYPES.DOUBLE,
	DATA_TYPES.DECIMAL,
	DATA_TYPES.DATE,
	DATA_TYPES.DATEONLY,
	DATA_TYPES.BOOLEAN,
	DATA_TYPES.ARRAY,
	DATA_TYPES.BLOB,
	DATA_TYPES.UUID,
];
